import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useColorMode, Box, useColorModeValue } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

interface DarkModeProps {
    scrolled?: boolean;
}

export default function DarkMode({ scrolled = false }: DarkModeProps) {
    const { colorMode, toggleColorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const borderColor = useColorModeValue(
        scrolled ? "rgba(10,22,40,0.10)" : "rgba(10,22,40,0.15)",
        scrolled ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.15)"
    );
    const iconColor = useColorModeValue("#0A1628", "#E8E0D0");

    return (
        <Box
            as="button"
            onClick={toggleColorMode}
            w="36px"
            h="36px"
            borderRadius="lg"
            border="1px solid"
            borderColor={borderColor}
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            bg="transparent"
            transition="all 0.3s cubic-bezier(0.16, 1, 0.3, 1)"
            _hover={{
                borderColor: "#C9A84C",
                bg: "rgba(201,168,76,0.06)",
                transform: "scale(1.05)",
            }}
            _focus={{ outline: "none", boxShadow: "none" }}
            aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
        >
            <AnimatePresence mode="wait" initial={false}>
                {isDark ? (
                    <motion.div
                        key="sun"
                        initial={{ rotate: 90, opacity: 0, scale: 0.6 }}
                        animate={{ rotate: 0,  opacity: 1, scale: 1   }}
                        exit={{    rotate: -90, opacity: 0, scale: 0.6 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        <FiSun size={16} color={iconColor} />
                    </motion.div>
                ) : (
                    <motion.div
                        key="moon"
                        initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
                        animate={{ rotate: 0,   opacity: 1, scale: 1   }}
                        exit={{    rotate: 90,  opacity: 0, scale: 0.6 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        <FiMoon size={16} color={iconColor} />
                    </motion.div>
                )}
            </AnimatePresence>
        </Box>
    );
}